export default function(categories) {
    // Parse all dates (support DD-MM-YYYY and ISO)
    const dates = categories.map(str => {
        const match = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(str)
        if (match) {
            const [ , day, month, year ] = match
            return new Date(`${year}-${month}-${day}`)
        }
        return new Date(str)
    })

    const allSame = (getter) => dates.every(d => getter(d) === getter(dates[0]))

    if (!allSame(d => d.getFullYear())) {
        // Return positions where year changes
        const years = dates.map(d => d.getFullYear())
        return years.map((y, i, arr) => i === 0 || y !== arr[i - 1] ? i : null).filter(i => i !== null)
    }

    if (!allSame(d => d.getMonth())) {
        const months = dates.map(d => d.getMonth())
        return months.map((m, i, arr) => i === 0 || m !== arr[i - 1] ? i : null).filter(i => i !== null)
    }

    const getWeek = d => {
        const firstDay = new Date(d.getFullYear(), 0, 1)
        return Math.ceil((((d - firstDay) / 86400000) + firstDay.getDay() + 1) / 7)
    }

    if (!allSame(getWeek) && categories.length > 14) {
        const weeks = dates.map(getWeek)
        return weeks.map((w, i, arr) => i === 0 || w !== arr[i - 1] ? i : null).filter(i => i !== null)
    }

    if (!allSame(d => d.getDate())) {
        const days = dates.map(d => d.getDate())
        return days.map((day, i, arr) => i === 0 || day !== arr[i - 1] ? i : null).filter(i => i !== null)
    }

    if (!allSame(d => d.getHours())) {
        const hours = dates.map(d => d.getHours())
        return hours.map((h, i, arr) => i === 0 || h !== arr[i - 1] ? i : null).filter(i => i !== null)
    }

    return []
}